<mat-sidenav-container
  fullscreen
  autosize
  [hasBackdrop]="false"
  [class.sidenav-pinned]="sidenavPinned()"
  [class.sidenav-expanded]="sidenavPinned()"
>
  @if (isSidenavDisplayed()) {
    <mat-sidenav
      class="invert-theme"
      opened
      disableClose
      [mode]="sidenavPinned() ? 'side' : 'over'"
      [fixedInViewport]="true"
    >
      <app-sidenav />
    </mat-sidenav>
  }

  <mat-sidenav-content
    [class.noPadding]="!isSidenavDisplayed()"
    [class.isShifted]="sidenavPinned() === false"
  >
    <app-navbar />
    <router-outlet />
  </mat-sidenav-content>
</mat-sidenav-container>

@if (!isSidenavDisplayed()) {
  <app-zendesk-floating-button />
}
